import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[eventsApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
            headers: error.response.headers,
        });
    } else {
        console.error(`[eventsApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export default {
    /**
     * Получить историю событий сущности
     * @param {string} target - Тип сущности: 'work' | 'facility' | 'customer' | 'contract' | 'user'
     * @param {number|string} id - ID сущности
     * @param {object} params - Параметры запроса
     * @param {number} params.page - Номер страницы (default: 1)
     * @param {string|string[]} params.verb - Фильтр по типу события
     * @returns {Promise<{count: number, next: string|null, previous: string|null, results: Array}>}
     */
    async getEvents(target, id, { page = 1, verb } = {}) {
        const params = { page };

        // Поддержка множественных фильтров verb
        if (verb) {
            if (Array.isArray(verb)) {
                // Если массив, добавляем каждый параметр отдельно
                verb.forEach(v => {
                    if (!params.verb) params.verb = [];
                    params.verb.push(v);
                });
            } else {
                params.verb = verb;
            }
        }

        try {
            const response = await axiosInstance.get(`${target}/${id}/events/`, { params });
            return response.data; // { count, next, previous, results }
        } catch (error) {
            logAndRethrow(`GET ${target}/${id}/events/`, error);
        }
    },
};
